"use client";
import useLocalStorage from "hooks/useLocalStorage";
import React, { createContext, useContext, ReactNode } from "react";
import { AppPageContext, AppPageProps } from "types/provider/Page";
import CategoryService, {
  CATEGORY_WITH_CHILDREN_SELECTION,
} from "services/category";
import ProvinceService from "services/province";
import { get } from "utils/lodash";
import helper from "utils/helper";
import usePromise from "hooks/usePromise";
export const PageContext = createContext<AppPageContext>({
  isSSR: false,
});

interface TypeUsePageContext {
  (): AppPageContext;
}

const PageProvider = ({
  children,
  initialCategories,
  initialSubCategories,
  initialProvinces,
  pageContext,
  ...props
}: AppPageProps): ReactNode => {
  const [province, $province] = useLocalStorage(
    "@lookme::province-v1",
    "686a7e84fc7940dcf9bb772a",
  );
  const [categories, $categories] = useLocalStorage(
    "@lookme::categories",
    initialCategories || [],
  );
  const [subCategories, $subCategories] = useLocalStorage(
    "@lookme::subCategories",
    initialSubCategories || [],
  );
  const [provinces, $provinces] = useLocalStorage(
    "@lookme::provinces-new",
    initialProvinces || [],
  );
  // usePromise(
  //   async () => {
  //     // if (categories.length === 0 || provinces.length === 0) {
  //     const responses = await helper.callAll(
  //       () => {
  //         return CategoryService.find(
  //           {
  //             where: {
  //               isActive: { equals: true },
  //             },
  //             limit: 100,
  //             page: 0,
  //           },
  //           CATEGORY_WITH_CHILDREN_SELECTION,
  //         );
  //       },
  //       () => {
  //         return ProvinceService.find({ page: 0, limit: 100 });
  //       },
  //     );
  //     const allCategory = get(responses, "0.data", []);
  //     const categories = allCategory.filter(
  //       (item: any) => item.type === "MAIN",
  //     );
  //     const subCategories = allCategory.filter(
  //       (item: any) => item.type === "SUB",
  //     );
  //     const provinces = get(responses, "1.data", []);
  //     $categories(categories);
  //     $subCategories(subCategories);
  //     $provinces(provinces);
  //     // }
  //     return null;
  //   },
  //   null,
  //   [],
  // );
  const pageService = {
    categories,
    subCategories,
    province,
    provinces,
    $categories,
    $provinces,
    onChangeProvince: (province: any) => {
      const value = get(province, "value") || province;
      $province(value);
    },
    clearData: () => {
      $categories([]);
      $subCategories([]);
      $provinces([]);
    },
  };
  return (
    <PageContext.Provider
      value={{
        ...pageContext,
        pageService,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageContext: TypeUsePageContext = () => {
  return useContext(PageContext);
};
export default PageProvider;
